import { useMutation } from '@tanstack/react-query';
import {
  OilStoreService,
  UploadTransactionImageDto,
  UploadTransactionImageEntity,
} from 'services/openapi';

export type UploadOilStoreType = {
  param: UploadTransactionImageDto;
};

export const useUploadOilStoreLicenseMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<
      UploadTransactionImageEntity,
      Error,
      UploadOilStoreType & { file: File }
    >({
      mutationFn: (request: UploadOilStoreType) => {
        return OilStoreService.oilStoreControllerUploadTransactionImage(
          request.param,
        );
      },
      onSuccess: async (data, { file }) => {
        const { sasUrl } = data;

        try {
          const res = await fetch(sasUrl, {
            method: 'PUT',
            headers: {
              'Content-Type': file.type,
              'x-ms-blob-type': 'BlockBlob',
            },
            body: file,
          });

          if (!res.ok) {
            throw error;
          }

          return data;
        } catch (error) {
          throw error;
        }
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
